import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function formatMoney(value, currency = 'تومان') {
  const amount = Number(value);

  if (!Number.isFinite(amount)) {
    return `0 ${currency}`;
  }

  return `${amount.toLocaleString('fa-IR')} ${currency}`;
}

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
